import { createReducer, on } from '@ngrx/store';
import { ReportSkinHealthGuidelineActions } from './health-guideline.actions';
import { ReportSkinHealthGuidelineState } from './health-guideline.interface';
import {
  initialReportSkinHealthGuidelineState,
  reportSkinHealthGuidelineState
} from './health-guideline.state';

export const reportSkinHealthGuidelineReducer = createReducer(
  reportSkinHealthGuidelineState,
  on(
    ReportSkinHealthGuidelineActions.reset,
    (): ReportSkinHealthGuidelineState =>
      initialReportSkinHealthGuidelineState()
  ),
  on(
    ReportSkinHealthGuidelineActions.setLoading,
    (state, { loading }): ReportSkinHealthGuidelineState => ({
      ...state,
      loading
    })
  ),
  on(
    ReportSkinHealthGuidelineActions.setMinimizePreviewPicture,
    (state, { minimizePreviewPicture }): ReportSkinHealthGuidelineState => ({
      ...state,
      minimizePreviewPicture
    })
  ),
  on(
    ReportSkinHealthGuidelineActions.setFaceBlueprint,
    (state, { faceBlueprint }): ReportSkinHealthGuidelineState => ({
      ...state,
      faceBlueprint
    })
  ),
  on(
    ReportSkinHealthGuidelineActions.setSkinInsight,
    (state, { skinInsight }): ReportSkinHealthGuidelineState => ({
      ...state,
      skinInsight
    })
  ),
  on(
    ReportSkinHealthGuidelineActions.setAllergySensitivity,
    (state, { allergySensitivity }): ReportSkinHealthGuidelineState => ({
      ...state,
      allergySensitivity
    })
  ),
  on(
    ReportSkinHealthGuidelineActions.setFaceBlueprintSelected,
    (state, { faceBlueprintSelected }): ReportSkinHealthGuidelineState => ({
      ...state,
      faceBlueprintSelected
    })
  )
);
